import { faCompressArrowsAlt } from "@fortawesome/pro-regular-svg-icons/faCompressArrowsAlt";
import { faExpandArrowsAlt } from "@fortawesome/pro-regular-svg-icons/faExpandArrowsAlt";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useMprcTheme } from "components/MprcThemeProvider";
import * as React from "react";
import { MprcIconButton, MprcIconButtonProps } from "../MprcIconButton";

interface IProps {
    expanded: boolean;
}

type Props = IProps & MprcIconButtonProps;

export const IconButtonExpandScreen: React.FC<Props> = (props) => {
    const { expanded, title, ...rest } = props;
    const { theme } = useMprcTheme();

    const finalTitle = title != null ? title
        : expanded
            ? theme.iconButtons.IconButtonRestoreScreen.title
            : theme.iconButtons.IconButtonFullScreen.title

    return (
        <MprcIconButton
            title={finalTitle}
            {...rest}
        >
            <FontAwesomeIcon fixedWidth icon={expanded ? faCompressArrowsAlt : faExpandArrowsAlt} />
        </MprcIconButton>
    );
};
